import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=89ad8344&scoped=true"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=89ad8344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ad8344",
  null
  
)

export default component.exports